import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { Typogaphy } from 'vnetwork-ui'
import type { Role } from '../../types'
import dayjs from 'dayjs'

export const RoleColumns: GridColDefVNW<Role>[] = [
    {
        field: 'id',
        headerName: 'ID',
        width: 300,
    },
    {
        field: 'name',
        headerName: 'roles-name',
        width: 460,
        renderCell: ({ row }: { row: Role }) => (
            <Typogaphy size="small" className="font-medium">
                {row?.name || ''}
            </Typogaphy>
        ),
    },
    {
        field: 'description',
        headerName: 'roles-description',
        width: 400,
        renderCell: ({ row }: { row: Role }) => (
            <Typogaphy size="small">
                {row?.description || 'Không có mô tả'}
            </Typogaphy>
        ),
    },
    {
        field: 'created_at',
        headerName: 'roles-created-at',
        width: 200,
        renderCell: ({ row }: { row: Role }) => (
            <Typogaphy size="small">
                {row?.created_at
                    ? dayjs(row.created_at).format('DD/MM/YYYY HH:mm')
                    : ''}
            </Typogaphy>
        ),
    },
]
